import React from "react";
import { LegalLayout } from "./LegalLayout";

const LAST_UPDATED = "12 June 2026";

/**
 * Terms of Service — UK consumer law compliant.
 * Company details filled in (Worthify Ltd, Glasgow G69 6GA, ICO C1956536) — Jun 2026.
 */
export const TermsPage = ({ t, language = "en" }) => {
  if (language === "pl") {
    return (
      <LegalLayout title="Regulamin świadczenia usług" lastUpdated={LAST_UPDATED} t={t} language={language}>
        <h2>1. Kim jesteśmy</h2>
        <p>
          Worthify (dalej „<strong>my</strong>", „<strong>nasz</strong>" lub „<strong>Worthify</strong>") to internetowa usługa
          dostarczająca raporty oceny ryzyka zakupu używanego samochodu w Wielkiej Brytanii na podstawie publicznych danych DVSA MOT,
          publicznych danych dekodera VIN (NHTSA vPIC), pełnego dostępu do rejestrów <strong>Global Vehicle Data</strong>
          (pay-per-lookup) — żywego źródła zasilającego cały zakres premium: znaczniki MIAFTR (szkody / write-off), aktywne
          umowy HP/PCP, sprawdzenie PNC (kradzież), wykrywanie anomalii przebiegu i bieżące wyceny rynkowe — oraz analizy
          wykonanej przez konsensus 3 niezależnych modeli AI.
        </p>
        <p>
          <strong>Dane firmy:</strong> Worthify, prowadzona przez <strong>Worthify Ltd</strong> (Company No. <strong>SC892241</strong>), adres: Unit 08, Flexspace / Glasgow Business Park, Springhill Parkway, Baillieston, Glasgow, G69 6GA.
          Numer rejestracji ICO: <strong>C1956536</strong>. Kontakt: <a href="mailto:support@worthify.co.uk">support@worthify.co.uk</a>.
        </p>

        <h2>2. Czym jest nasza usługa</h2>
        <ul>
          <li><strong>Free Check (£0)</strong> — natychmiastowy werdykt kup / ostrożnie / unikaj, podstawowe dane pojazdu, status MOT i podatku.</li>
          <li><strong>Standard Check za £1</strong> (oferta limitowana, normalnie £9.99) — odblokowuje Worthify Buy Score, wyjaśnienia AI, szczegółowy MOT, mocne i słabe strony pojazdu oraz wstępną ocenę ryzyka.</li>
          <li><strong>Full Check za £4.99</strong> — wszystko z planu Standard plus sprawdzenie aktywnych umów finansowania, sprawdzenie kradzieży, znaczniki MIAFTR (szkody / write-off), wykrywanie anomalii przebiegu, bieżąca wycena rynkowa oraz raport PDF do pobrania.</li>
          <li><strong>AI Call Assistant za £2.99 (za połączenie)</strong> — autonomiczna AI głosowa Pine.ai dzwoni do sprzedawcy w Twoim imieniu, korzystając z danych z raportu, dopytuje o brakujące informacje i negocjuje cenę. Otrzymujesz pełną transkrypcję i podsumowanie.</li>
        </ul>
        <p>
          Każdy zakup dotyczy <strong>jednej rejestracji</strong> i jest płatnością jednorazową. Brak subskrypcji, brak automatycznego odnawiania.
        </p>

        <h2>3. Co Worthify NIE jest</h2>
        <p>
          Worthify dostarcza <strong>analizę i estymacje</strong> oparte na danych publicznych i licencjonowanych rejestrach oraz
          modelach statystycznych. Full Check <strong>obejmuje</strong> bieżące sprawdzenie aktywnych umów finansowania, kradzieży
          i znaczników MIAFTR (write-off / ubezpieczenie) za pośrednictwem Global Vehicle Data. Worthify <strong>NIE</strong>
          jest jednak:
        </p>
        <ul>
          <li>Inspekcją mechaniczną — nie zastępuje fizycznej kontroli przez mechanika przed zakupem</li>
          <li>Gwarancją stanu technicznego pojazdu</li>
          <li>Wyceną oficjalną do celów ubezpieczeniowych, kredytowych lub podatkowych</li>
          <li>Pełną weryfikacją prawną tytułu własności ani wielodekadowym łańcuchem historii własności</li>
        </ul>
        <p>
          Decyzje o zakupie pojazdu podejmujesz na własne ryzyko. Zalecamy zawsze osobistą inspekcję pojazdu i niezależną kontrolę mechaniczną przed zakupem.
        </p>

        <h2>4. Płatności</h2>
        <p>
          Płatności są przetwarzane przez <strong>Stripe Payments Europe Ltd</strong>. Worthify nie przechowuje danych Twojej karty. Ceny zawierają wszystkie obowiązujące podatki.
        </p>
        <p>
          Za każdym razem gdy płacisz, otrzymujesz cyfrowy raport dostępny natychmiast w przeglądarce — usługa jest <strong>świadczona w momencie zapłaty</strong>.
        </p>

        <h2>5. Polityka zwrotów</h2>
        <p>
          Zgodnie z <strong>Consumer Contracts Regulations 2013</strong> (UK), zamawiając cyfrowy raport i wyraźnie potwierdzając jego natychmiastową dostawę (klikając „Unlock" / „Odblokuj"), <strong>rezygnujesz z 14-dniowego prawa odstąpienia</strong>.
        </p>
        <p>
          Mimo to, jeśli raport zawiera wadę techniczną (np. brak danych DVSA dla podanej rejestracji, błąd serwera uniemożliwiający wyświetlenie wyniku), <strong>masz prawo do zwrotu pieniędzy</strong>. Skontaktuj się z nami w ciągu 14 dni od zakupu: <a href="mailto:support@worthify.co.uk">support@worthify.co.uk</a>.
        </p>

        <h2>6. Twoje obowiązki</h2>
        <ul>
          <li>Podajesz wyłącznie rejestracje pojazdów, do których masz uzasadniony interes (np. rozważasz zakup)</li>
          <li>Nie używasz Worthify w celach masowego scrapowania danych ani odsprzedaży raportów</li>
          <li>Nie próbujesz obchodzić zabezpieczeń płatniczych</li>
          <li>Nie używasz usługi do działań niezgodnych z prawem (kradzież tożsamości, oszustwo)</li>
        </ul>
        <p>
          Możemy zablokować dostęp do usługi w przypadku naruszenia tych warunków.
        </p>

        <h2>7. Ograniczenie odpowiedzialności</h2>
        <p>
          Worthify ponosi odpowiedzialność wyłącznie do wysokości <strong>zapłaconej ceny raportu</strong> (£1 lub £4.99). Nie ponosimy odpowiedzialności za pośrednie straty (utracone zyski, koszty zakupu pojazdu, koszty napraw).
        </p>
        <p>
          Nic w niniejszym Regulaminie nie ogranicza Twoich praw konsumenckich zgodnie z <strong>Consumer Rights Act 2015</strong> (UK) ani odpowiedzialności za śmierć lub szkody na osobie spowodowane naszym zaniedbaniem.
        </p>

        <h2>8. Własność intelektualna</h2>
        <p>
          Platforma Worthify, oprogramowanie, raporty, algorytmy, systemy AI, projekty graficzne, branding, treści oraz autorskie metodologie są chronione prawem autorskim, prawami do znaków towarowych, tajemnicą przedsiębiorstwa oraz przepisami o własności intelektualnej.
        </p>
        <p>
          <strong>Technologia własnościowa — Patent Pending.</strong> Technologia Worthify jest przedmiotem brytyjskiego zgłoszenia patentowego nr <strong>GB2613261.3</strong> pod tytułem: <em>„An Integrated Autonomous AI System for Analysis, Valuation, Risk Assessment and Negotiation"</em> (Zintegrowany autonomiczny system AI do analizy, wyceny, oceny ryzyka i negocjacji).
        </p>
        <p>
          Żadna część platformy Worthify — oprogramowanie, raporty, kod źródłowy, metodologie, branding ani technologia własnościowa — nie może być kopiowana, reprodukowana, poddawana inżynierii wstecznej, modyfikowana, rozpowszechniana ani komercyjnie wykorzystywana bez uprzedniej pisemnej zgody Worthify Ltd.
        </p>
        <p>
          Nazwa Worthify, logo, platforma i powiązana własność intelektualna pozostają wyłączną własnością Worthify Ltd. Możesz pobrać i drukować raport PDF do <strong>użytku osobistego</strong> związanego z zakupem konkretnego pojazdu. Nie wolno odsprzedawać ani publicznie udostępniać raportów.
        </p>

        <h2>9. Zmiany regulaminu</h2>
        <p>
          Możemy aktualizować ten Regulamin. Najnowsza wersja zawsze dostępna na <code>worthify.co.uk/terms</code>. Data ostatniej aktualizacji: <strong>{LAST_UPDATED}</strong>.
        </p>

        <h2>10. Prawo właściwe</h2>
        <p>
          Niniejsza umowa podlega prawu Anglii i Walii. Spory rozstrzygane są przez sądy angielskie i walijskie.
        </p>

        <h2>11. Kontakt</h2>
        <p>
          Pytania, reklamacje, zwroty: <a href="mailto:support@worthify.co.uk">support@worthify.co.uk</a>. Staramy się odpowiadać w ciągu 3 dni roboczych.
        </p>
      </LegalLayout>
    );
  }

  // English (default)
  return (
    <LegalLayout title="Terms of Service" lastUpdated={LAST_UPDATED} t={t} language={language}>
      <h2>1. Who we are</h2>
      <p>
        Worthify (the "<strong>Service</strong>", "<strong>we</strong>", "<strong>us</strong>") is an online service that produces
        used-car risk-assessment reports for UK vehicles, based on the public DVSA MOT history database, the public NHTSA vPIC VIN
        decoder, full <strong>Global Vehicle Data</strong> registry access (pay-per-lookup) — a live source powering all
        premium-tier provenance: MIAFTR insurance / write-off markers, outstanding HP/PCP finance, PNC stolen/theft check, mileage
        anomaly detection and live market valuations — and a 3-model AI consensus analysis.
      </p>
      <p>
        <strong>Trading details:</strong> Worthify, operated by <strong>Worthify Ltd</strong> (Company No. <strong>SC892241</strong>), registered address: Unit 08, Flexspace / Glasgow Business Park, Springhill Parkway, Baillieston, Glasgow, G69 6GA.
        ICO registration number: <strong>C1956536</strong>. Contact: <a href="mailto:support@worthify.co.uk">support@worthify.co.uk</a>.
      </p>

      <h2>2. What you get</h2>
      <ul>
        <li><strong>Free Check (£0)</strong> — instant buy / caution / avoid verdict, basic vehicle information, MOT and tax status.</li>
        <li><strong>£1 Standard Check</strong> (limited time, normally £9.99) — unlocks the Worthify Buy Score, AI explanations, detailed MOT insights, vehicle strengths &amp; weaknesses and initial risk assessment.</li>
        <li><strong>£4.99 Full Check</strong> — everything in Standard, plus outstanding finance check, stolen vehicle check, MIAFTR write-off / insurance markers, mileage anomaly detection, live valuations and a downloadable PDF report.</li>
        <li><strong>£2.99 AI Call Assistant (per call)</strong> — Pine.ai autonomous voice AI phones the seller on your behalf using your report data, gathers missing information and negotiates the price. You receive a full transcript and summary.</li>
      </ul>
      <p>
        Every purchase covers <strong>one vehicle registration</strong> and is a single payment. No subscription, no auto-renewal.
      </p>

      <h2>3. What Worthify is NOT</h2>
      <p>
        Worthify provides <strong>analysis and estimates</strong> based on public + licensed registry data and statistical models.
        The Full Check <strong>does include</strong> live outstanding finance, stolen vehicle and insurance/write-off (MIAFTR) checks
        sourced via Global Vehicle Data. However, Worthify is still <strong>not</strong>:
      </p>
      <ul>
        <li>A mechanical inspection — it does not replace a physical pre-purchase inspection by a mechanic</li>
        <li>A warranty or guarantee of a vehicle's technical condition</li>
        <li>An official valuation for insurance, finance, or tax purposes</li>
        <li>A legal title verification or a deep multi-decade title-chain history</li>
      </ul>
      <p>
        You make purchase decisions at your own risk. We strongly recommend an in-person inspection and an independent mechanical check before buying any used vehicle.
      </p>

      <h2>4. Payments</h2>
      <p>
        Payments are processed by <strong>Stripe Payments Europe Ltd</strong>. Worthify does not store your card details. All prices include applicable taxes.
      </p>
      <p>
        Each time you pay, the digital report is delivered <strong>immediately</strong> in your browser — service is rendered at the moment of payment.
      </p>

      <h2>5. Refund policy</h2>
      <p>
        Under the UK <strong>Consumer Contracts Regulations 2013</strong>, by paying for a digital report and confirming immediate delivery (clicking "Unlock"), you <strong>waive your 14-day cooling-off right</strong>.
      </p>
      <p>
        However, if the report contains a technical defect (for example DVSA data is unavailable for the registration you submitted, or a server error prevents the report from displaying), <strong>you are entitled to a full refund</strong>. Contact us within 14 days of purchase: <a href="mailto:support@worthify.co.uk">support@worthify.co.uk</a>.
      </p>

      <h2>6. Acceptable use</h2>
      <ul>
        <li>You only submit registrations for vehicles where you have a legitimate interest (typically because you are considering a purchase)</li>
        <li>You do not use Worthify for bulk scraping or commercial re-distribution of reports</li>
        <li>You do not attempt to bypass our paywall or rate limits</li>
        <li>You do not use the Service for any unlawful activity</li>
      </ul>
      <p>
        We may suspend or terminate access if these terms are breached.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        Our maximum liability to you is limited to the <strong>price paid for the report</strong> (£1 or £4.99). We are not liable for indirect or consequential losses (lost profits, vehicle purchase price, repair costs).
      </p>
      <p>
        Nothing in these Terms limits your statutory rights under the UK <strong>Consumer Rights Act 2015</strong>, or our liability for death or personal injury caused by our negligence, or for fraud.
      </p>

      <h2>8. Intellectual property</h2>
      <p>
        The Worthify platform, software, reports, algorithms, AI systems, designs, branding, content and proprietary methodologies are protected by copyright, trademark rights, trade secrets and intellectual property laws.
      </p>
      <p>
        <strong>Proprietary Technology — Patent Pending.</strong> Worthify technology is the subject of UK Patent Application No. <strong>GB2613261.3</strong> entitled: <em>"An Integrated Autonomous AI System for Analysis, Valuation, Risk Assessment and Negotiation."</em>
      </p>
      <p>
        No part of the Worthify platform, software, reports, source code, methodologies, branding or proprietary technology may be copied, reproduced, reverse engineered, modified, distributed or commercially exploited without the prior written consent of Worthify Ltd.
      </p>
      <p>
        The Worthify name, logo, platform and associated intellectual property remain the exclusive property of Worthify Ltd. You may download and print the PDF report for <strong>personal use</strong> in connection with a specific vehicle purchase. You may not resell or publicly distribute reports.
      </p>

      <h2>9. Changes to these terms</h2>
      <p>
        We may update these Terms. The latest version is always available at <code>worthify.co.uk/terms</code>. Last updated: <strong>{LAST_UPDATED}</strong>.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These Terms are governed by the laws of England and Wales. Any disputes will be resolved by the courts of England and Wales.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions, complaints, refund requests: <a href="mailto:support@worthify.co.uk">support@worthify.co.uk</a>. We aim to respond within 3 business days.
      </p>
    </LegalLayout>
  );
};